import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { getProReorder } from '../../../../Store/prosafe/proReport/getProReorder';
import Header from '../../Include/Header';
import Sidebar from '../../Include/Sidebar';
import Footer from '../../Include/Footer';
import Loader from '../../Include/Loader';
import { Pagination, Search } from '../../Table';
import DropDown from '../../../../Components/DropDown';

const ProReOrder = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [limit, setlimit] = useState(10);
    const [disable, setDisable] = useState(true);

    useEffect(() => {
        if (disable === true) {
            const formData = new URLSearchParams();
            formData.append('search', "");
            formData.append('firm_id', localStorage.getItem('PAY_USER_FIRM_ID'));
            // formData.append('year_id', localStorage.getItem('PAY_USER_YEAR_ID'));
            dispatch(getProReorder({ formData }))
            setDisable(false);
        }
    }, [disable]);

    const entity = useSelector((state) => state?.getProReorder?.user?.data);

    const commentsData = useMemo(() => {
        let computedComments = entity || [];
        if (search.trim() !== "") {
            const lowerSearch = search.toLowerCase();
            computedComments = computedComments.filter((item) =>
                item?.item_name?.toLowerCase().includes(lowerSearch) ||
                item?.m_code?.toLowerCase().includes(lowerSearch) ||
                item?.category?.toLowerCase().includes(lowerSearch) ||
                item?.unit?.toLowerCase().includes(lowerSearch) ||
                item?.lastPurchaseParty?.toLowerCase().includes(lowerSearch) ||
                item?.lastIssueParty?.toLowerCase().includes(lowerSearch)
            );
        }
        setTotalItems(computedComments?.length);
        return computedComments?.slice(
            (currentPage - 1) * limit,
            (currentPage - 1) * limit + limit
        );
    }, [currentPage, search, limit, entity]);

    const handleRefresh = () => {
        setDisable(true);
        setSearch('');
    }

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen)
    }

    return (
        <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>
            <Header handleOpen={handleOpen} />
            <Sidebar />

            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="row">
                            <div className="col-sm-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/main-store/user/dashboard">Dashboard </Link></li>
                                    <li className="breadcrumb-item"><i className="feather-chevron-right"></i></li>
                                    <li className="breadcrumb-item active">Re-Order Items List</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {disable === false ? (
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card card-table show-entire">
                                    <div className="card-body">
                                        <div className="page-table-header mb-2">
                                            <div className="row align-items-center">
                                                <div className="col">
                                                    <div className="doctor-table-blk">
                                                        <h3>Re-Order Items</h3>
                                                        <div className="doctor-search-blk">
                                                            <div className="top-nav-search table-search-blk">
                                                                <form>
                                                                    <Search
                                                                        onSearch={(value) => {
                                                                            setSearch(value);
                                                                            setCurrentPage(1);
                                                                        }}
                                                                    />
                                                                    {/* eslint-disable jsx-a11y/anchor-is-valid */}
                                                                    <a className="btn">
                                                                        <img src="/assets/img/icons/search-normal.svg" alt="firm-searchBox" />
                                                                    </a>
                                                                </form>
                                                            </div>
                                                            <div className="add-group">
                                                                <button type="button" onClick={handleRefresh} className="btn btn-primary doctor-refresh ms-2"
                                                                    data-toggle="tooltip" data-placement="top" title="Refresh">
                                                                    <img src="/assets/img/icons/re-fresh.svg" alt="refresh" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="pageDropDown col-auto text-end float-end ms-auto download-grp">
                                                    <DropDown limit={limit} onLimitChange={(val) => setlimit(val)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table border-0 custom-table comman-table  mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Sr.</th>
                                                        <th>Item Name</th>
                                                        <th>Code</th>
                                                        <th>Unit</th>
                                                        <th>Category</th>
                                                        <th>Balance</th>
                                                        <th>Re-Order Qty</th>
                                                        <th>Order Qty</th>
                                                        <th>Last Purchase</th>
                                                        <th>Last Issue</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {commentsData?.map((elem, i) =>
                                                        <tr key={i}>
                                                            <td>{(currentPage - 1) * limit + i + 1}</td>
                                                            <td>{elem?.item_name}</td>
                                                            <td>{elem?.m_code}</td>
                                                            <td>{elem?.unit}</td>
                                                            <td>{elem?.category}</td>
                                                            <td>{elem?.balance}</td>
                                                            <td>{elem?.reorder_quantity}</td>
                                                            <td>{elem?.order_qty}</td>
                                                            <td>
                                                                <div><strong>Date:</strong> {elem?.lastPurchaseDate ? new Date(elem?.lastPurchaseDate).toLocaleDateString() : 'N/A'}</div>
                                                                <div><strong>Party:</strong> {elem?.lastPurchaseParty || 'N/A'}</div>
                                                                <div><strong>Rate:</strong> ₹{elem?.lastPurchaseRate || '-'}</div>
                                                                <div><strong>Voucher:</strong> {elem?.lastPurchaseVoucher || '-'}</div>
                                                            </td>
                                                            <td>
                                                                {elem?.lastIssueDate ? (
                                                                    <>
                                                                        <div><strong>Date:</strong> {new Date(elem?.lastIssueDate).toLocaleDateString()}</div>
                                                                        <div><strong>Party:</strong> {elem?.lastIssueParty || 'N/A'}</div>
                                                                        <div><strong>Rate:</strong> ₹{elem?.lastIssueRate || '-'}</div>
                                                                        <div><strong>Voucher:</strong> {elem?.lastIssueVoucher || '-'}</div>
                                                                    </>
                                                                ) : (
                                                                    'N/A'
                                                                )}
                                                            </td>
                                                        </tr>
                                                    )}
                                                    {commentsData?.length === 0 ? (
                                                        <tr>
                                                            <td colSpan="999">
                                                                <div className="no-table-data">
                                                                    No Data Found!
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ) : null}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="row align-center mt-3 mb-2">
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                                                <div className="dataTables_info" id="DataTables_Table_0_info" role="status"
                                                    aria-live="polite">Showing {Math.min(limit, totalItems)} from {totalItems} data</div>
                                            </div>
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                                                <div className="dataTables_paginate paging_simple_numbers"
                                                    id="DataTables_Table_0_paginate">
                                                    <Pagination
                                                        total={totalItems}
                                                        itemsPerPage={limit}
                                                        currentPage={currentPage}
                                                        onPageChange={(page) => setCurrentPage(page)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : <Loader />}
                </div>
                <Footer />
            </div>
        </div>
    )
}

export default ProReOrder